import { render, staticRenderFns } from "./ManageRequests.vue?vue&type=template&id=a9603ad4&scoped=true&"
import script from "./ManageRequests.vue?vue&type=script&lang=js&"
export * from "./ManageRequests.vue?vue&type=script&lang=js&"
import style0 from "./ManageRequests.vue?vue&type=style&index=0&id=a9603ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9603ad4",
  null
  
)

export default component.exports